var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"blister",class:_vm.adherenceStatus,on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.index))])}
var staticRenderFns = []

export { render, staticRenderFns }